import localizeCurrency from "@helpers/localizeCurrency";
import { useTranslation } from "react-i18next";
import { Plan, StripePrice } from "src/types";

interface Props {
  currency: string;
  periodAmount: number;
  periodUnit: string;
  plan: Plan;
  stripeIntroPrice: StripePrice | undefined;
  stripePrice: StripePrice | undefined;
  timeLeft: string;
  setSelectedPlan: (plan: Plan) => void;
  selectedPlan: Plan;
}

export default function PlanCard({
  currency,
  periodAmount,
  periodUnit,
  plan,
  stripeIntroPrice,
  stripePrice,
  timeLeft,
  setSelectedPlan,
  selectedPlan,
}: Props) {
  const { t } = useTranslation();

  if (!stripePrice || !stripeIntroPrice) return null;
  console.log(periodUnit);

  const hasCurrencyOption =
    !!stripeIntroPrice.currency_options?.[currency]?.unit_amount_decimal;

  const price = parseFloat(
    hasCurrencyOption
      ? stripePrice.currency_options[currency].unit_amount_decimal
      : stripePrice?.unit_amount_decimal,
  );

  const introPrice = parseFloat(
    hasCurrencyOption
      ? stripeIntroPrice.currency_options[currency].unit_amount_decimal
      : stripeIntroPrice?.unit_amount_decimal,
  );

  const priceCurrency = hasCurrencyOption ? currency : stripePrice.currency;
  const divider = periodAmount === 12 ? 52 : 1;

  if (!price) return null;

  const pricePerPeriod = price / divider;
  const introPricePerPeriod = introPrice / divider;

  const localizePrice = (price: number | undefined) => {
    if (!price) return "";

    return localizeCurrency({
      amountInCents: price,
      currency: priceCurrency,
    });
  };

  return (
    <div onClick={() => setSelectedPlan(plan)} className="cursor-pointer">
      <div className="group">
      


        <div
          className={`${plan === selectedPlan ? "custom-plan-card" : "custom-plan-card-gray"} rounded-3xl border-0 p-2 px-6 text-center`}
        >
          <div className="flex flex-col items-center justify-between gap-4 p-2">
            {/* <div className="flex items-center gap-2">
              <div
                className={`h-6 w-6 rounded-full border-2 ${plan === selectedPlan ? "border-white" : "border-white"} flex items-center justify-center`}
              >
                {plan === selectedPlan && (
                  <div className="h-3 w-3 rounded-full bg-white"></div>
                )}
              </div>
              <div className="flex flex-row items-baseline gap-1">
                <p className="font-bold text-2xl">{periodAmount}</p>
                <p className="text-lg">
                {t(`pages.checkout.plans.${periodUnit}_${periodAmount === 1 ? "one" : "other"}`)}
                </p>
              </div>
            </div> */}

            <div className="flex flex-col items-center gap-1">
              <p className="text-2xl line-through">
                {localizePrice(pricePerPeriod)}
              </p>

              <p className="text-2xl font-bold">
                {t("pages.checkout.plans.aWeek", {
                  price: localizePrice(introPricePerPeriod),
                })}
              </p>

              <p className="text-base text-gray-400 line-through pt-2">
                {t("pages.checkout.plans.billedWeeklyAt", {
                  price: localizePrice(pricePerPeriod),
                })}
              </p>

              <p className="text-base font-semibold text-gray-400">
                {t("pages.checkout.plans.firstWeekSpecialOffer", {
                  price: localizePrice(pricePerPeriod),
                })}
              </p>

              {timeLeft !== "00:00" && (
              <p className="mt-4 text-center text-base font-semibold">
                <span className="rounded-xl bg-[#D65353] px-8 py-2 text-white">
                  {t("pages.checkout.plans.offerEnds", { countdown: timeLeft })}
                </span>
              </p>
            )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
